import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { store } from './Store';
const root = ReactDOM.createRoot(document.getElementById('root'));

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
window.baseurl = BASE_URL;
window.api = `${BASE_URL}api/v1/`;

const WINDOW_BASEURL2 = process.env.REACT_APP_WINDOW_BASEURL2;
window.baseurl2 = WINDOW_BASEURL2

// window.baseurl= 'https://bgi.sortstring.com/';
// window.api= 'https://bgi.sortstring.com/api/V1/';
// window.baseurl2= 'https://bitevns.org/';
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

